import { N70 } from "./CustomerGroupSales/N70";
import { N71 } from "./DistrictManager/N71";
import { N70_02 } from "./ProductSales/N70_02";
import { N69_01 } from "./ProductSalesPerf/N69_01";
import { N71_02 } from "./PMR/N71_02";

export const RegionalCustomerGroupProduct = {
  "sections": [
    N70,
    N70_02,
    N69_01,
    N71,
    N71_02
  ]
}